// extracted by mini-css-extract-plugin
export default {"section":"Error_section__PwxcR","page404":"Error_page404__x6ILu"};